<a [class]="'linkIcon ' + ' ' + fromVisibility(visibility) + ' ' + fromSize(size)"
   [class._disabled]="disabled"
   [class._noMargin]="noMargin"
   [class._collapseLink]="collapse">
    <ng-content></ng-content>
</a>
